import { render, staticRenderFns } from "./SalesDetails.vue?vue&type=template&id=a37a474a&scoped=true&"
import script from "./SalesDetails.vue?vue&type=script&lang=js&"
export * from "./SalesDetails.vue?vue&type=script&lang=js&"
import style0 from "./SalesDetails.vue?vue&type=style&index=0&id=a37a474a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37a474a",
  null
  
)

export default component.exports